/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, lockedBy: NonNullable<unknown> }} Explorer_Kanban_Move_Locked_ToastInputs */



/**
* | output |
* | --- |
* | "Cannot move \"{name}\" as it is locked by {lockedBy}" |
*
* @param {Explorer_Kanban_Move_Locked_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_move_locked_toast = /** @type {((inputs: Explorer_Kanban_Move_Locked_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Move_Locked_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de deplacer "${i?.name}" car il est verrouille par ${i?.lockedBy}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" kann nicht verschoben werden, da es von ${i?.lockedBy} gesperrt ist.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile spostare "${i?.name}" perché è bloccato da ${i?.lockedBy}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Невозможно переместить "${i?.name}", так как он заблокирован ${i?.lockedBy}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede mover "${i?.name}" ya que está bloqueado por ${i?.lockedBy}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法移动“${i?.name}”，因为它被“${i?.lockedBy}”锁定。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」は${i?.lockedBy}によってロックされているため移動できません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.name}" को स्थानांतरित नहीं किया जा सकता क्योंकि यह ${i?.lockedBy} द्वारा लॉक किया गया है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não é possível mover "${i?.name}" porque está bloqueado por ${i?.lockedBy}`)
	return /** @type {LocalizedString} */ (`Cannot move "${i?.name}" as it is locked by ${i?.lockedBy}`)
});